var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _mask4, _rect4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_423_63",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.188576,
    y: 0.715576,
    width: 9.45545,
    height: 12.2921,
    rx: 0.768253
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.188576,
    y: 0.715576,
    width: 9.45545,
    height: 12.2921,
    rx: 0.768253,
    stroke: "white",
    strokeWidth: 2.30476,
    mask: "url(#path-1-inside-1_423_63)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_423_63",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13.7808,
    y: 1.07019,
    width: 9.45344,
    height: 6.3824,
    rx: 0.768253
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7808,
    y: 1.07019,
    width: 9.45344,
    height: 6.3824,
    rx: 0.768253,
    stroke: "white",
    strokeWidth: 2.30476,
    mask: "url(#path-2-inside-2_423_63)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_423_63",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.2537,
    y: 11.8257,
    width: 8.9806,
    height: 11.9375,
    rx: 0.768253
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2537,
    y: 11.8257,
    width: 8.9806,
    height: 11.9375,
    rx: 0.768253,
    stroke: "white",
    strokeWidth: 2.30476,
    mask: "url(#path-3-inside-3_423_63)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_423_63",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.18853,
    y: 17.7354,
    width: 9.21913,
    height: 6.02784,
    rx: 0.768253
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.18853,
    y: 17.7354,
    width: 9.21913,
    height: 6.02784,
    rx: 0.768253,
    stroke: "white",
    strokeWidth: 2.30476,
    mask: "url(#path-4-inside-4_423_63)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard_icon.efa3c8c12e1baaf2c7a47a9e430c2b52.svg";
export { ForwardRef as ReactComponent };